var jQuery = require("jquery");
var $ = jQuery;
global.$ = jQuery;
global.jQuery = jQuery;
global.jquery = jQuery;

jQuery.event.special.touchstart = {
    setup: function (_, ns, handle) {
        this.addEventListener("touchstart", handle, {
            passive: true
        });
    }
};

let href = $(location).attr('href');

var slick = require('slick-slider');

var noUiSlider = require('nouislider');
global.noUiSlider = noUiSlider;

var selectpicker = require('bootstrap-select');

var fancybox = require('fancybox')($);
global.fancybox = fancybox;

var Cookies = require('js-cookie');
global.Cookies = Cookies;

require('bootstrap/js/dist/util');
require('bootstrap/js/dist/dropdown');
require('bootstrap/js/dist/button');
require('bootstrap/js/dist/tooltip');
require('bootstrap/js/dist/collapse');
